import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import useDeleteWorkoutTemplate from 'hooks/workoutTemplate/useDeleteWorkoutTemplate';
import { WorkoutTemplateList } from 'types';
import notificationHandler from 'utils/notifications';

const ModalWorkoutTemplateDelete = ({
  opened,
  template,
  handleClose,
}: {
  opened: boolean;
  handleClose: () => void;
  template: WorkoutTemplateList | null;
}): JSX.Element => {
  const { mutate, isLoading } = useDeleteWorkoutTemplate();
  const { successNotification, errorNotification } = notificationHandler();

  const handleDelete = (): void => {
    if (!template?.workoutTemplateId) return;
    mutate(template.workoutTemplateId, {
      onSuccess: () => {
        successNotification('Workout template deleted', `${template.name} has been deleted successfully.`);
      },
      onError: error => {
        const errorMessage = error.response?.data?.message || 'Failed to delete workout template';
        errorNotification('Delete failed', errorMessage);
      },
      onSettled: () => {
        handleClose();
      },
    });
  };

  return (
    <Modal
      centered
      opened={opened}
      onClose={handleClose}
      title={<Title order={4}>Delete Workout Template?</Title>}
      size='auto'
    >
      <Stack>
        <Text>
          Are you sure you want to delete <strong>{template?.name ?? 'this workout template'}</strong>?
        </Text>
        <Text color='dimmed'>This action cannot be undone.</Text>
        <Group position='right'>
          <Button variant='subtle' onClick={handleClose}>
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            color='red'
            loading={isLoading}
            disabled={!template?.workoutTemplateId}
          >
            Delete Permanently
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalWorkoutTemplateDelete;
